import { WprBaseValidator } from '../../../wpr-framework/view/validation/WprBaseValidator';

export class CreditCardNameValidator extends WprBaseValidator {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('クレジットカード名義');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 入力値チェック
	 * @param value 入力値
	 * @param option チェックオプション
	 * @returns trueの場合、成功
	 */
	public checkValidValue(value: any, option?: any): boolean {
		if (!value)
			return true;
		if (typeof (value) === 'string' || value instanceof String) {
			if (value.match('^[A-Z]+\\s[A-Z]+$') != null)
				return true;
		}
		return false;
	}

	/**
	 * エラーメッセージ取得
	 * @param option オプション
	 * @returns エラーメッセージ
	 */
	public getErrorMessage(option?: any): string {
		return '半角英大文字で入力してください';
	}
}